<template>
    <v-card stretch>
        <div v-padding="3">
            <form-search @search="$emit('search', $event)" />
        </div>
        <v-data-table :loader="loading" @sort="$emit('sort', $event)" :sort="sort" :headers="headers"
            :records="records">
            <template slot="cell-datetime" scope="props">
                <v-text nowrap>
                    {{ moment(props.item.datetime).format('DD.MM.YYYY HH:mm') }}
                </v-text>
            </template>

            <template slot="cell-subjectType" scope="props">
                <v-text nowrap>
                    {{ props.item.isJuridical ? 'Юр. лицо' : 'Физ. лицо' }}
                </v-text>
            </template>

            <template slot="cell-reportLink" scope="props">
                <v-text nowrap>
                    <span v-for="reportLink in sortedLinks(props.item.reportLinks)">
                        <v-link v-margin.left="1" v-if="reportLink.title.toLocaleUpperCase() === 'HTML'"
                            to="javascript:;" @click="handleLoadReportPreview(reportLink.link)">
                            HTML
                        </v-link>
                        <v-link v-margin.left="1" v-else :to="reportLink.link" target="_blank">
                            {{ reportLink.title.toLocaleUpperCase() }}
                        </v-link>
                    </span>
                </v-text>
            </template>

            <template slot="cell-statusName" scope="props">
                <v-icon-button v-if="isRenderCommentButton(props.item)" v-margin.top="-1" v-margin.left="-5"
                    @click.stop="handleShowComments(props.item.comments)">
                    comment
                </v-icon-button>
                <v-text v-if="props.item.statusName==='В работе'" nowrap>
                    <v-tooltip text="Средний срок обработки отчета 5 мин.">
                        {{ props.item.statusName }}
                    </v-tooltip>
                </v-text>
                <v-text v-else nowrap>
                        {{ props.item.statusName }}
                </v-text>
            </template>
        </v-data-table>
        <div v-padding="3">
            <v-pagination @click="$emit('paginate', $event)" :total="total" :display="display" :current="page" />
        </div>

        <v-modal auto-width :active="reportPreview">
            <div v-padding="2">
                <div v-text-align.right>
                    <v-icon-button @click="reportPreview = false">
                        clear
                    </v-icon-button>
                </div>
            </div>

            <div v-padding="2">
                <v-spinner v-if="!report" block />
                <div :style="{ overflowX: 'auto', height: report === '' ? '0px' : 'auto' }">
                    <iframe id="report" :style="{ border: 0 }">
                    </iframe>
                </div>
            </div>.

            <div v-padding="2">
                <div v-text-align.right>
                    <v-button flat primary @click="reportPreview = false">
                        закрыть
                    </v-button>
                </div>
            </div>
        </v-modal>

        <v-modal :active="isShowComments" @close="handleHideComments">
            <div v-padding="2">
                <div v-for="(comment, index) in comments" :key="index">
                    <div v-margin.bottom="1">
                        <v-text bold>
                            {{ moment(comment.created).format('DD.MM.YYYY HH:mm') }}
                        </v-text>
                    </div>
                    <v-text>
                        {{ comment.body }}
                    </v-text>

                    <div v-padding.top.bottom="1">
                        <v-separator />
                    </div>
                </div>

                <div v-text-align.right v-margin.top="2">
                    <v-button flat primary @click="handleHideComments">
                        закрыть
                    </v-button>
                </div>
            </div>
        </v-modal>
    </v-card>
</template>
<script>
import moment from 'moment';
import FormSearch from './FormSearch';
const delayMs = 5000;
export default {
    name: 'requests',
    props: {
        loading: Boolean,
        sort: Object,
        records: Array,
        total: {
            type: Number,
            default: 0,
        },
        page: {
            type: Number,
            default: 1,
        },
        display: {
            type: Number,
            default: 10,
        },
        onLoadReportPreview: Function,
        fetchIntervalRequestSearch: Function,
    },
    components: {
        FormSearch,
    },
    data() {
        return {
            report: '',
            reportPreview: false,
            headers: {
                datetime: { label: 'Дата' },
                subjectName: { label: 'Субъект' },
                subjectType: { label: 'Тип субъекта' },
                productName: { label: 'Вид отчета' },
                reportLink: { label: 'Отчет' },
                statusName: { label: 'Статус' },
            },
            comments: [],
        }
    },
    methods: {
        moment,
        handleLoadReportPreview(link) {
            this.reportPreview = true;
            this.report = '';

            this.onLoadReportPreview(link)
                .then((res) => {
                    this.report = res.data;
                    const iframe = document.getElementById('report');

                    var style = document.createElement('style')
                    style.textContent =
                        `.ki-report-header {
    display: block;
}

.ki-report-header > h2 {
    padding: 0 20px 30px 0;
    line-height: 28px;
    margin: 0 !important;
    width: 380px;
    float: left;
}

.ki-report-left {
    float: left;
}

.ki-report-gray {
    color: #7d7d7d;
}

.ki-report-red {
    color: #ff0000;
}

.ki-report-green {
    color: #009900;
}

.ki-report-tabs > ul {
    margin: 0 !important;
    padding: 0;
    list-style: none;
    display: inline-block;
    text-align: left;
}

.ki-report-tabs > ul > li {
    display: inline-block;
    padding: 0;
    border-radius: 4px 4px 0 0;
    border: 1px solid #e8e8e8;
    background: #ffffff;
    background: -moz-linear-gradient(top, #ffffff 5%, #e6e6e6 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(5%, #ffffff), color-stop(100%, #e6e6e6));
    background: -webkit-linear-gradient(top, #ffffff 5%, #e6e6e6 100%);
    background: -o-linear-gradient(top, #ffffff 5%, #e6e6e6 100%);
    background: -ms-linear-gradient(top, #ffffff 5%, #e6e6e6 100%);
    background: linear-gradient(to bottom, #ffffff 5%, #e6e6e6 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#e6e6e6', GradientType=0);
    margin: 0 3px -1px 0;
}

.ki-report-tabs > ul > li.select {
    background: #fff;
    border-bottom: 1px solid #fff;
}

.ki-report-tabs > ul > li > a {
    font-size: 13px;
    line-height: 13px;
    min-width: 63px;
    text-decoration: none;
    padding: 7px 10px;
    display: inline-block;
    text-align: center;
    vertical-align: bottom;
}

.ki-report-tabs > ul > li.select > a {
    padding-top: 11px;
    color: #03949f;
}

table.ko-report-spreadsheet tr td {
    border-bottom: 1px solid #e8e8e8;
}

table.ko-report-spreadsheet tr td:first-child {
    padding-left: 30px;
}

table.ko-report-spreadsheet {
    width: 100%;
    margin-top: 6px;
    margin-bottom: 15px;
    text-align: left;
}

table.ko-report-spreadsheet td {
    padding: 3px 20px;
}

table.ko-report-spreadsheet > thead + tbody > tr:first-child > td {
    box-shadow: 0 9px 9px -9px #bbb inset;
}

table.ko-report-spreadsheet thead td {
    background: #77c100;
    color: #fff;
    padding-top: 6px;
    padding-bottom: 6px;
    border-top: 0 !important;
}

table.ko-report-spreadsheet > tbody > td {
    vertical-align: top;
    border-width: 0 !important;
}

table.ko-report-spreadsheet > tbody > tr:last-child td {
    border-width: 1px !important;
    border-right: 0 !important;
}

table.ko-report-spreadsheet > tbody > .bg > td {
    background: #f5f5f7;
}

table.ko-report-spreadsheet > td {
    padding-left: 30px;
    padding-right: 30px;
}

table.ko-report-spreadsheet td {
    padding-left: 8px;
    padding-right: 8px;
}

table.ko-report-spreadsheet td:first-child {
    padding-left: 20px;
}

table.ko-report-spreadsheet td:last-child {
    padding-right: 20px;
}

table.ko-report-spreadsheet thead td {
    border-top: 0 !important;
}

table.ko-report-spreadsheet h4 {
    margin-top: 8px;
    margin-bottom: 5px;
}

table.ko-report-spreadsheet > tbody > tr.bg_red > td {
    background: #ffdddd !important;
}

table.ko-report-spreadsheet tbody tr:nth-child(odd) td {
    background: #f5f5f7;
}

table.ko-report-spreadsheet:not(.nohover) > tbody > tr:hover > td {
    background-color: #dbf1fc !important;
}

div.ki-report-documents table.ko-report-spreadsheet td:first-child {
    width: 100px;
}

.reports table {
    border-collapse: collapse;
    border-spacing: 0;
}

.ki-report-accounts table {
    width: 100%;
    margin-top: 0;
    margin-bottom: 15px;
    text-align: left;
}

.ki-report-accounts table td {
    padding: 3px 20px;
}

.ki-report-accounts table td {
    width: 195px;
}

.ki-report-accounts table.notwidth td {
    width: auto;
}

.ki-report-accounts table td:first-child {
    width: auto;
    vertical-align: top;
}

.ki-report-accounts table.firstnowrap td:first-child {
    white-space: nowrap;
}

.ki-report-accounts table thead td {
    background: #77c100;
    color: #fff;
    padding-top: 6px;
    padding-bottom: 6px;
    border-top: 0 !important;
}

.ki-report-accounts .close thead .title {
    font-weight: normal;
    position: absolute;
}

.ki-report-accounts .close thead .title {
    display: inline;
}

.ki-report-accounts .open thead .title,
.ki-report-accounts .close thead span,
.ki-report-accounts .close tbody,
.ki-report-accounts .close tfoot {
    display: none;
}

.ki-report-accounts table.legend thead td {
    font-weight: bold;
    width: auto;
    background: #ffffff;
    color: #3d3d3d;
}

.ki-report-accounts table.legend tbody tr:nth-child(odd) td,
.ki-report-accounts table.legend tbody td {
    line-height: 24px;
    padding-right: 20px;
    font-size: 11px;
    vertical-align: top;
    width: auto;
    background: #ffffff;
}

.ki-report-accounts table.attention-account thead td {
    background: #ac0000;
}

.ki-report-accounts table .min {
    width: 14px;
    height: 14px;
    float: right;
    position: relative;
    color: #ffffff;
    text-align: center;
    line-height: 12px;
    cursor: pointer;
    font-size: 21px;
    margin-top: 2px;
    right: -11px;
    font-weight: 400;
}

.ki-report-accounts .pay {
    display: inline-block;
    border: 1px solid #d9d9d9;
    font-weight: bold;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    font-size: 13px;
}

.ki-report-accounts .pay_0 {
    color: #70a500;
}

.ki-report-accounts .pay_a {
    color: #cab900;
}

.ki-report-accounts .pay_1 {
    color: #b1a700;
}

.ki-report-accounts .pay_2 {
    color: #d4a000;
}

.ki-report-accounts .pay_3 {
    color: #a55d00;
}

.ki-report-accounts .pay_4 {
    color: #ca3e00;
}

.ki-report-accounts .pay_5 {
    color: #8b0000;
}

.ki-report-accounts .pay_6 {
    color: #680000;
}

.ki-report-accounts .pay_70 {
    color: #ccc;
}

.ki-report-accounts .pay_7 {
    color: #727272;
}

.ki-report-accounts .pay_8 {
    color: #3f3f3f;
}

.ki-report-accounts .pay_- {
    background: #b5b5b5;
    color: #fff;
    line-height: 17px;
}

.ki-report-accounts tfoot .month,
.ki-report-accounts tfoot .month {
    display: inline-block;
    text-align: center;
    margin-top: 5px;
}

.ki-report-accounts tfoot .month .pay,
.ki-report-accounts tfoot .month .pay {
    display: block;
}

.ko-report-red {
    color: #ff0000;
}
    a[data-tab-switch] {
        cursor:pointer;
    }
`

                    var script = document.createElement('script');
                    script.textContent = `
                            document.querySelectorAll('a[data-tab-switch]').forEach((el) =>{
                                el.addEventListener('click', (event) => {
                                    var selectTags = document.querySelectorAll('.select');
                                    selectTags.forEach((sTag) => sTag.classList.remove('select'));
                                    event.target.parentElement.classList.add('select');
                                    document.querySelectorAll('div[data-tab]').forEach((div) => div.style.display = 'none');
                                    document.querySelector('div[data-tab='+event.target.attributes.getNamedItem('data-tab-switch').value+']').style.display = 'block';
                                });
                            })

                            document.querySelectorAll('.min').forEach((el) =>{
                                el.addEventListener('click', (event) => {
                                    const symbol = event.target.innerHTML;
                                    if(symbol === "+"){
                                        event.target.parentElement.parentElement.parentElement.parentElement.classList.remove('close');
                                        event.target.innerHTML = "-"
                                    } else {
                                        event.target.parentElement.parentElement.parentElement.parentElement.classList.add('close');
                                        event.target.innerHTML = "+"
                                    }                                    
                                });
                            })

                            document.querySelectorAll('.js-kko-report-show-next').forEach((el) =>{
                                el.addEventListener('click', (event) => {
                                    const child = event.currentTarget.parentElement.querySelector('.js-kko-report-block-opening');      
                                    if (child.style.display) {
                                        child.style.display = null;
                                    } else {
                                        child.style.display = 'none';
                                    }
                                });
                            })
                        `
                    iframe.contentDocument.write(this.report);
                    iframe.width = 1424;
                    iframe.height = iframe.contentWindow.document.body.scrollHeight;
                    iframe.contentDocument.head.appendChild(style);
                    iframe.contentDocument.body.appendChild(script);

                })
        },

        sortedLinks(links) {
            const sortedLinks = [...links].sort((a, b) => {
                if (a.title > b.title) {
                    return 1;
                }
                if (a.title < b.title) {
                    return -1;
                }
                return 0;
            });
            return sortedLinks
        },

        isRenderCommentButton(request) {
            return request.comments && request.comments.length;
        },

        handleShowComments(comments) {
            this.comments = comments;
        },

        handleHideComments(comments) {
            this.comments = [];
        },

        handleUpdateStatus() {
            this.intervalId = setInterval(() => {
                var ignoredProducts = [7, 35];
                const hasInProgress = this.records.some(record => record.status === 5 && !ignoredProducts.includes(record.productId))
                if (hasInProgress && this.intervalId) {
                    this.fetchIntervalRequestSearch()
                } else {
                    clearInterval(this.intervalId)
                }
            }, delayMs)
        },

    },
    computed: {
        isShowComments() {
            return this.comments.length > 0;
        }
    },
    mounted() {
        this.handleUpdateStatus()
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
    }
}
</script>



// WEBPACK FOOTER //
// Requests.vue?05acda02